var map = {
	"./_main/common.js": "./src/block/common/_main/common.js",
	"./_main/styles.scss": "./src/block/common/_main/styles.scss",
	"./app-link/app-link.js": "./src/block/common/app-link/app-link.js",
	"./custom/custom.js": "./src/block/common/custom/custom.js",
	"./custom/custom.scss": "./src/block/common/custom/custom.scss",
	"./forms/forms.js": "./src/block/common/forms/forms.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/block/common sync recursive ^\\.\\/[^/]+\\/[^/.]+\\.(js%7Ccss%7Cscss%7Csass%7Cless)$";